const MIME_CANDIDATES = [
  'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
  'video/mp4',
  'video/webm;codecs=vp8,opus',
  'video/webm;codecs=vp9,opus',
  'video/webm',
];

/** Safari records mp4. Chrome on Android records webm. */
export function pickRecorderMime(isTypeSupported) {
  if (typeof isTypeSupported !== 'function') return '';
  return MIME_CANDIDATES.find((type) => isTypeSupported(type)) || '';
}

export function clipExtension(mime) {
  return String(mime || '').includes('mp4') ? 'mp4' : 'webm';
}
